import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Cliente } from "../../../interfaces/clientes/cliente.interface";

interface initialStateType {
  clientToEdit?: Cliente;
  page: number;
  size: number;
}

const initialState: initialStateType = {
  page: 0,
  size: 10,
};

const clientesSlice = createSlice({
  initialState,
  name: "clientes",
  reducers: {
    setClienteToEdit: (state, action: PayloadAction<Cliente | undefined>) => {
      state.clientToEdit = action.payload;
    },
    setPageTableClientes: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setSizeTableClientes: (state, action: PayloadAction<number>) => {
      state.size = action.payload;
    },
    resetClientesState: () => initialState,
  },
});

export const {
  setClienteToEdit,
  setPageTableClientes,
  setSizeTableClientes,
  resetClientesState,
} = clientesSlice.actions;

export default clientesSlice.reducer;
